import React, { useEffect, useState } from 'react';
import './AddQuestion.css'
import { Button } from '@material-ui/core/'
import firebase_ from '../../../firebase/firebase';
import { Redirect } from 'react-router-dom'
import Select from 'react-dropdown-select';
import SelectSearch from 'react-select-search';
import swal from 'sweetalert';

function AddQuestion(props) {
    const [question, setQuestion] = useState('')
    const [technology, setTechnology] = useState('')
    const [images, setImages] = useState('')
    const [flag, setFlag] = useState(false)
    const [inputFile, setInputFile] = useState(null)
    const [technologyFetch, setTechnologyFetch] = useState([])

    const db = firebase_.firestore()
    const storage = firebase_.storage()
    useEffect(() => {
        db.collection('Technologies').get()
            .then(async (res) => {
                await res.forEach(async (element) => {
                    var tech = {
                        "name": await element.data()['name'],
                        "value": await element.data()['name']
                    }
                    setTechnologyFetch(technologyFetch => [...technologyFetch, tech])

                })
                console.log('--', technologyFetch);
            }).catch(err => {
                console.log('error in fetching technologies', err);
            })
    }, [])
    const handleChange = (e) => {
        if (e.target.name === "question") {
            setQuestion(e.target.value)
        } else if (e.target.name === "technology") {
            setTechnology(e.target.value)
        }
    }
    const handleChangeFile = (e) => {
        setInputFile(e.target.files[0])

    }
    const handleSubmit = (e) => {
        e.preventDefault()
        console.log('--', technology, '--->>', technologyFetch);
        console.log(question, technology, inputFile);
        if (inputFile !== null) {
            
            var storageRef = storage.ref();
            var spaceRef = storageRef.child(`images/${inputFile['name']}`)
            spaceRef.put(inputFile)
                .then(async res => {
                    db.collection('Questions').add({
                        "question": question,
                        "technology": technology,
                        "askedBy": [{
                            "userName":sessionStorage.getItem('userName'),
                            "emailId" : sessionStorage.getItem('emailId'),
                            "profileImageUrl" : sessionStorage.getItem('imgUrl')
                        }],
                        "imgUrl": await spaceRef.getDownloadURL(),
                        "answers": [{
                            "answerBy": "",
                            "answer": "",
                            "imgUrl": ""
                        }]
                    }).then((res) => {
                        console.log('response after ading', res);
                        swal("Question added sucessfully!", "Wait for someone to answer", "success");

                        setFlag(true)
                    }).catch(err => {
                        console.log('error while adding question ', err);
                    })
                })
                .catch(err => {
                    console.log('error while uploading', err);
                })

        } else {
            db.collection('Questions').add({
                "question": question,
                "technology": technology,
                "askedBy": [{
                    "userName":sessionStorage.getItem('userName'),
                    "emailId" : sessionStorage.getItem('emailId'),
                    "profileImageUrl" : sessionStorage.getItem('imgUrl')
                }],
                "imgUrl": "",
                "answers": [{
                    "answerBy": "",
                    "answer": "",
                    "imgUrl": ""
                }]
            }).then((res) => {
                console.log('response after ading', res);
                swal("Question added sucessfully!", "Wait for someone to answer", "success");

                setFlag(true)
            }).catch(err => {
                console.log('error while adding question ', err);
            })
        }


    }
    const sweetAlert = () =>{
        swal("Good job!", "You clicked the button!", "success");
    }
    if (flag) {
        return (
            <div>
                <Redirect to="/dashboard" />
            </div>
        )
    }
    return (

        <div>
            <div className="add-question">
                <form onSubmit={handleSubmit}>
                    <label for="question">Question</label>
                    <input className="add-question-inpt" onChange={handleChange} type="text" id="question" name="question" placeholder="Question / Placeholder" />

                    <label for="technology">Technology</label>
                    {/* <input className="add-question-inpt" onChange={handleChange} type="text" id="technology" name="technology" placeholder="Technology" /> */}
                    {/* <Select options={technologyFetch} nam="technology" onChange={(values) => setTechnology(values)} /> */}
                    
                        <SelectSearch  options={
                            technologyFetch
                        } value="sv" name="technology" onChange={(value) => setTechnology(value)} placeholder="Choose your language" />
                    
                    <input className="attach-img" onChange={handleChangeFile} type="file" name="inputFile" />
                    <Button className="add-question-btn" type="submit">
                        Add Question
                    </Button>
                </form>
            </div>
        </div>
    );
}

export default AddQuestion;